export default __webpack_public_path__ + "static/media/banner3.eb7c38f7.png";